import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS , GREATER_THAN_ZERO} from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function FormaPago(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                 
                                    {props.onGetFieldDecorator(`arrMetodoPagoOtros[${row.identifier}]`, {
                                        rules: [{
                                            required: false,
                                        }]
                                    })(
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(value)}
                                        />
                                    )}

                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Fecha Pago',
                        dataIndex: 'fecha',
                        key: 'fecha',
                        align: 'center',
                        width: 160,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrFecha[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                            onBlur={(e) => { props.onChange("Fecha" ,"fecha", e.target.value, row.identifier ,index);}}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

           /*          {
                        title: 'Cuota',
                        dataIndex: 'nroCouta',
                        key: 'nroCouta',
                        width: 80,
                        visible: false,
              
                    }, */
                    
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'idMetodoPago',
                        key: 'idMetodoPago',
                        width: 160,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMetodoPago[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Pago"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onChange(option.label, "idMetodoPago",option.key,row.identifier,index );}}
                                        >
                                            {props.listaMetodoPago.map((item) => (
                                                item.nombre.split(" ")[0].toUpperCase()!="NOTA"?
                                                (      
                                                    (item.id==4 ? null:<Option key={item.id} value={item.id}>{item.nombre}</Option>)
                                            
                                                ): null

                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Banco',
                        dataIndex: 'idBanco',
                        key: 'idBanco',
                        width: 160,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrBanco[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Banco"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onChange(option.label ,"idBanco", option.key, row.identifier,index );}}

                                        >
                                            {props.listaBanco.map(item => (
                                            <Option key={item.id} value={item.id}>{item.razonSocial}</Option>
                                        ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                     {
                        title: 'Cuenta',
                        dataIndex: 'idDestino',
                        key: 'idDestino',
                        width: 160,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridDestino[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: false,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Cuenta"}
                                            optionFilterProp="children"
                                            onChange={(option) => { props.onChangeCuenta(option.label ,"idDestino", option.key, row.identifier,index );}}

                                        >
                                            {props.listaCuentaDestino.map(item => (
                                            <Option key={item.id} value={item.id}>{item.cuentaBancario}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    }, 

                    {
                        title: 'Nro Operación',
                        dataIndex: 'referencia',
                        key: 'referencia',
                        width: 160,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrreferencia[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: false,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Referencia"
                                            autoComplete="off"
                                            onBlur={(e) => { props.onChange("Referencia" ,"idReferencia", e.target.value, row.identifier,index );}}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

    
                    {
                        title: 'Monto a Cobrar',
                        dataIndex: 'montoCuota',
                        key: 'montoCuota',
                        width: 160,
                        render: (value, row,index) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMontoCuota[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Monto de Cobrar debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Monto de Cuota"
                                            autoComplete="off"
                                            onBlur={(e) => { props.onChange("Monto" ,"idMonto", e.target.value, row.identifier,index );}}

                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
               
                ]}
            />
        </div>
    );
}